module.exports = __webpack_public_path__ + "img/IMG_9432_L_WoodMatted_MockedUp.2a8d0929.jpg";